import { useMemo } from "react";
import DOMPurify from "dompurify";

// Questa policy è applicata all'anteprima, indipendentemente dalla CSP Report-Only
// dell'app. Nessuna richiesta di rete, neppure tramite immagini o CSS del template.
const PREVIEW_CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:; font-src data:; base-uri 'none'; form-action 'none'";

function buildPreviewDocument(html: string): string {
  const documentElement = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    WHOLE_DOCUMENT: true,
    RETURN_DOM: true,
    // È un'anteprima visiva: link, moduli e redirect non devono navigare neppure
    // dentro il frame. Il contenuto salvato/inviato via email resta invariato.
    FORBID_TAGS: ["base", "meta", "link", "form", "input", "button", "textarea", "select", "option", "iframe", "object", "embed", "video", "audio", "source", "track"],
    FORBID_ATTR: ["href", "target", "action", "formaction", "ping", "download", "srcset"],
  }) as HTMLHtmlElement; // WHOLE_DOCUMENT + RETURN_DOM restituiscono <html>.
  const head = documentElement.querySelector("head")!;
  const policy = documentElement.ownerDocument.createElement("meta");
  policy.httpEquiv = "Content-Security-Policy";
  policy.content = PREVIEW_CSP;
  // Solo markup fidato viene aggiunto DOPO la sanitizzazione; la policy precede
  // gli eventuali stili del template e quindi ne blocca anche @import/url().
  // Specificità zero: gli stili del template, anche sui pulsanti, prevalgono.
  // Gli href restano rimossi: questo recupera solo l'aspetto dei link.
  const linkStyle = documentElement.ownerDocument.createElement("style");
  linkStyle.textContent = ":where(a) { color: #0000ee; text-decoration: underline; }";
  head.prepend(policy, linkStyle);
  return `<!doctype html>${documentElement.outerHTML}`;
}

export function EmailPreview({ html, titolo = "Anteprima del template email" }: { html: string; titolo?: string }) {
  const srcDoc = useMemo(() => buildPreviewDocument(html), [html]);
  return (
    <>
      <iframe
        title={titolo}
        className="h-[420px] w-full rounded-lg border border-line bg-white"
        sandbox=""
        referrerPolicy="no-referrer"
        srcDoc={srcDoc}
      />
      <p className="mt-2 text-xs text-ink/50">
        Link e contenuti esterni sono disattivati nell’anteprima.
      </p>
    </>
  );
}
